var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 391.524 161.165",
    width: 391,
    height: 161,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#31c1b7",
    d: "M0 0h391.524v161.165H0z",
    "data-name": "Rectangle 43"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#31c1b7",
    clipPath: "url(#a)",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.329 46.099a5.933 5.933 0 0 0-5.932 5.932v28.624c0 16.514-12.041 31.29-28.479 32.891a31.674 31.674 0 0 1-34.8-31.484V52.031a5.932 5.932 0 1 0-11.865 0v28.511c0 22.037 15.752 41.7 37.572 44.615v24.145h-13.836a5.932 5.932 0 1 0 0 11.865h39.547a5.932 5.932 0 0 0 0-11.865h-13.84v-24.2a43.528 43.528 0 0 0 37.57-43.038V52.031a5.933 5.933 0 0 0-5.932-5.932",
    "data-name": "Path 37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.761 101.836a19.833 19.833 0 0 0 19.775-19.775V19.775a19.775 19.775 0 0 0-39.549 0v62.287a19.833 19.833 0 0 0 19.775 19.775",
    "data-name": "Path 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.756 0a5.933 5.933 0 0 0-5.932 5.932v108.014a5.932 5.932 0 1 0 11.865 0V5.932A5.933 5.933 0 0 0 108.756 0",
    "data-name": "Path 39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.461 34.232a5.933 5.933 0 0 0-5.932 5.932v39.548a5.932 5.932 0 1 0 11.865 0V40.164a5.933 5.933 0 0 0-5.932-5.932",
    "data-name": "Path 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.049 34.232a5.933 5.933 0 0 0-5.932 5.932v39.548a5.932 5.932 0 1 0 11.865 0V40.164a5.933 5.933 0 0 0-5.932-5.932",
    "data-name": "Path 41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.344 16.931a5.933 5.933 0 0 0-5.932 5.932v74.152a5.932 5.932 0 1 0 11.865 0V22.863a5.933 5.933 0 0 0-5.932-5.932",
    "data-name": "Path 42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.707 45.602v28.673a5.932 5.932 0 1 0 11.865 0V45.602a5.932 5.932 0 0 0-11.865 0",
    "data-name": "Path 43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.932 68.838a5.933 5.933 0 0 0 5.932-5.932v-5.933a5.932 5.932 0 0 0-11.864 0v5.932a5.933 5.933 0 0 0 5.932 5.932",
    "data-name": "Path 44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.767 0a5.933 5.933 0 0 0-5.932 5.932v108.014a5.931 5.931 0 1 0 11.863 0V5.932A5.933 5.933 0 0 0 282.767 0",
    "data-name": "Path 45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.472 34.232a5.933 5.933 0 0 0-5.932 5.932v39.548a5.932 5.932 0 1 0 11.865 0V40.164a5.933 5.933 0 0 0-5.932-5.932",
    "data-name": "Path 46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.179 102.948a5.933 5.933 0 0 0 5.932-5.932V22.863a5.932 5.932 0 1 0-11.865 0v74.152a5.933 5.933 0 0 0 5.932 5.932",
    "data-name": "Path 47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.817 74.275V45.602a5.932 5.932 0 0 0-11.865 0v28.673a5.932 5.932 0 0 0 11.865 0",
    "data-name": "Path 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.591 51.041a5.933 5.933 0 0 0-5.932 5.932v5.932a5.932 5.932 0 1 0 11.865 0v-5.932a5.933 5.933 0 0 0-5.932-5.932",
    "data-name": "Path 49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.06 34.232a5.933 5.933 0 0 0-5.932 5.932v39.548a5.932 5.932 0 0 0 11.865 0V40.164a5.933 5.933 0 0 0-5.932-5.932",
    "data-name": "Path 50"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.4972ec165e884a5f9bad774773e1e64e.svg";
export { ForwardRef as ReactComponent };